import { Component } from 'react'

import * as h from 'h'

export default class NotFound extends Component {
  render () {
    return h.h2(null, 'Portal: 404 Not Found')
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/NotFound/index.js